export default __webpack_public_path__ + "static/meshery-stats-b07da176492c8dbde68a93bc2133f19a.png";